import { Card, CardMedia } from '@mui/material'
import { useId } from 'react'

function BannerCard () {
  const k = useId()
  return (
    <Card>
      <CardMedia
        component="img"
        className="object-cover aspect-[3/1] bg-gray-700"
        image={`https://picsum.photos/800/400?${k}`}
        alt="banner"
      />
    </Card>
  )
}

export default BannerCard
